import { createSSRApp } from 'vue';
import MiniTray from '@rei/mini-tray-widget';
import ScsLibrary from '../../plugins/customChat/ScsLibrary';
import App from './helpCenterHome.vue';
import { useDataStore } from '../../store/useDataStore';

// eslint-disable-next-line import/no-unresolved
import '@rei/mini-tray-widget/style.css';

export default function createApp(props) {
  const app = createSSRApp(App);
  const store = useDataStore(props);
  app.provide('store', store);
  app.use(MiniTray);
  app.use(ScsLibrary);
  return { app, store };
}
